import React, { useMemo } from "react";
import "./styles.css";
import DeleteIcon from "../../icons/delete-icon";
import DeleteTrashIcon from "../../icons/delete-trash-icon";
import { colors } from "../../theme/colors";
import TwoCheckIcon from "../../icons/two-check-icon";

const RowIcon = ({ type = "remove" }) => {
  const RenderedIcon = useMemo(() => {
    if (type === "remove") {
      return <DeleteIcon className="delete-icon-container" />;
    } else if (type === "delete") {
      return <DeleteTrashIcon className="delete-icon-container" />;
    } else if (type === "enabled") {
      return <TwoCheckIcon className="success-icon-container" />;
    }
  }, [type]);

  return (
    <div
      className="row-icon-container"
      style={
        type === "enabled"
          ? { backgroundColor: colors["successColorLight"] }
          : { backgroundColor: colors["failureColorLight"] }
      }
    >
      {RenderedIcon}
    </div>
  );
};

export default RowIcon;
